import { USER_TYPE } from "@home-health-notify/domain";
import { UserDirectoryContext, useTranslation } from "hhn-commons";
import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { Group as GroupIcon } from "@mui/icons-material";
import { PatientHeaderDescription } from "../../../message/messageHeader/patientGroupHeader/PatientHeaderDescription";
import { IPatientHeaderProps } from "./AdvanceSearchHelper";

interface AdvanceSearchHeaderContentProps {
  patientHeaderProps: IPatientHeaderProps;
  existingMembers?: any[];
}

const AdvanceSearchHeaderContent = ({
  patientHeaderProps,
  existingMembers = [],
}: AdvanceSearchHeaderContentProps) => {
  const { t } = useTranslation();
  const tNAdvanceSearch = (key: string) => t(key, { ns: "advanceSearch" });
  const { userDirectory } = useContext(UserDirectoryContext);
  const activeUserDirectory = userDirectory.getActiveUserDirectory();

  const clinicianNames = existingMembers
    .map(member => {
      const userInfo = activeUserDirectory.find(
        user => user.id === member.userId && USER_TYPE.USER === user.type,
      );
      return userInfo?.name;
    })
    .filter(Boolean);

  return (
    <>
      <PatientHeaderDescription
        name={patientHeaderProps.name}
        patientStatus={patientHeaderProps.patientStatus}
        servicesToPatient={patientHeaderProps.servicesToPatient}
        meta={patientHeaderProps?.meta}
      />
      <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
        <GroupIcon sx={{ fontSize: 15, mr: 0.5 }} />
        <Typography variant="caption" sx={{ fontWeight: 700 }}>
          {tNAdvanceSearch("clinicians")}
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ lineHeight: 1.4 }}>
        {clinicianNames.length > 0
          ? clinicianNames.join(", ")
          : tNAdvanceSearch("noneAssigned")}
      </Typography>
    </>
  );
};

export default AdvanceSearchHeaderContent;
